<template>
	<div class="range-wrapper" :style="cssVariables">
		<input class="input" type="range" v-bind="$attrs" v-on="listeners" :value="value" />
		<slot name="range-thumb"><i class="range-thumb"></i></slot>
		<div class="range-fill-wrapper">
			<div class="range-fill"></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'RangeInput',
	props: {
		range: {
			type: Array,
		},
		value: {
			type: Number,
		},
		clamp: {
			type: Number,
		},
		thumbPercent: {
			type: Number,
			default: 10,
			validate: (width) => width > 0 && width < 100,
		},
	},
	computed: {
		listeners() {
			return {
				...this.$listeners,
				input: this.emitClampedValue,
			};
		},
		cssVariables() {
			return {
				"--thumb-width": `${this.thumbPercent}%`,
				"--thumb-position": `${this.thumbPosition}%`,
			};
		},
		thumbPosition() {
			const range = (this.range[1] - this.range[0]);
			const adjustedValue = this.value - this.range[0];

			return ((adjustedValue / range) * 100) * (1 - (this.thumbPercent / 100));
		},
	},
	methods: {
		emitClampedValue(event) {
			const value = typeof this.clamp === "number" ? Math.min(this.clamp, event.target.value) : event.target.value;
			this.$emit('input', value);

			if (event.target.value >= this.clamp) {
				this.$emit('clamped', value);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	$default-track-color: darkgray;
	$default-thumb-color: gray;
	$default-fill-color: lightgray;

	.range-wrapper {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.input {
		width: 100%;
		height: 100%;
		appearance: none;
		background: transparent;
		outline: none;

		&::-webkit-slider-runnable-track {
			cursor: pointer;
			height: 100%;
		}

		&::-moz-focus-outer { border: none; }

		&::-webkit-slider-thumb {
			width: var(--thumb-width, 10%);
			height: 100%;
			cursor: grab;
			position: relative;
			appearance: none;
			background: transparent;
			border: 0;

			&:active { cursor: grabbing; }
		}

		&::-moz-range-thumb {
			width: var(--thumb-width, 10%);
			height: 100%;
			cursor: grab;
			position: relative;
			appearance: none;
			background: transparent;
			border: none;

			&:active { cursor: grabbing; }
		}
	}

	.range-thumb {
		height: 100%;
		width: var(--thumb-width);
		position: absolute;
		left: var(--thumb-position);
		top: 0;
		bottom: 0;
		z-index: $z-top;
		margin: auto;
		background: var(--thumb-color, $default-thumb-color);
		pointer-events: none;

		@include mobile { padding: 10px 0; }
	}

	.range-fill-wrapper {
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: $z-mid;
		pointer-events: none;
	}

	.range-fill {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		margin: 0 auto;
		background: var(--track-color, $default-track-color);

		&::after {
			content:'';
			position: absolute;
			width: var(--thumb-position);
			top: 0;
			bottom: 0;
			left: 0;
			background: var(--fill-color, $default-fill-color);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/game/budget/RangeInput.vue